export const START_GET_COLLECTION_LIST = "START_GET_COLLECTION_LIST";
export const SUCCESS_GET_COLLECTION_LIST = "SUCCESS_GET_COLLECTION_LIST";
export const ERROR_GET_COLLECTION_LIST = "ERROR_GET_COLLECTION_LIST";

export const START_GET_COLLECTION_COUNT = "START_GET_COLLECTION_COUNT";
export const SUCCESS_GET_COLLECTION_COUNT = "SUCCESS_GET_COLLECTION_COUNT";
export const ERROR_GET_COLLECTION_COUNT = "ERROR_GET_COLLECTION_COUNT";

export const START_DELETE_COLLECTION = "START_DELETE_COLLECTION";
export const SUCCESS_DELETE_COLLECTION_GROUP =
  "SUCCESS_DELETE_COLLECTION_GROUP";
export const ERROR_DELETE_COLLECTION_GROUP = "ERROR_DELETE_COLLECTION_GROUP";

export const RESET_COLLECTION_STATE = "RESET_COLLECTION_STATE";

export const START_GET_COLLECTION_DETAIL = "START_GET_COLLECTION_DETAIL";
export const SUCCESS_GET_COLLECTION_DETAIL = "SUCCESS_GET_COLLECTION_DETAIL";
export const ERROR_GET_COLLECTION_DETAIL = "ERROR_GET_COLLECTION_DETAIL";

export const START_UPDATE_COLLECT_DATA = "START_UPDATE_COLLECT_DATA";
export const SUCCESS_UPDATE_COLLECT_DATA = "SUCCESS_UPDATE_COLLECT_DATA";
export const ERROR_UPDATE_COLLECT_DATA = "ERROR_UPDATE_COLLECT_DATA";

export const START_ADD_AND_UPDATE_NOTE = "START_ADD_AND_UPDATE_NOTE";
export const SUCCESS_ADD_AND_UPDATE_NOTE = "SUCCESS_ADD_AND_UPDATE_NOTE";
export const ERROR_ADD_AND_UPDATE_NOTE = "ERROR_ADD_AND_UPDATE_NOTE";

export const START_DELETE_NOTE = "START_DELETE_NOTE";
export const SUCCESS_DELETE_NOTE = "SUCCESS_DELETE_NOTE";
export const ERROR_DELETE_NOTE = "ERROR_DELETE_NOTE";

export const START_COLLECT_AND_REMOVE_MEDICATION =
  "START_COLLECT_AND_REMOVE_MEDICATION";
export const SUCCESS_COLLECT_AND_REMOVE_MEDICATION =
  "SUCCESS_COLLECT_AND_REMOVE_MEDICATION";
export const ERROR_COLLECT_AND_REMOVE_MEDICATION =
  "ERROR_COLLECT_AND_REMOVE_MEDICATION";
export const START_COLLECTED_AND_REMOVED_MEDICATION =
  "START_COLLECTED_AND_REMOVED_MEDICATION";
export const SUCCESS_COLLECTED_AND_REMOVED_MEDICATION =
  "SUCCESS_COLLECTED_AND_REMOVED_MEDICATION";
export const ERROR_COLLECTED_AND_REMOVED_MEDICATION =
  "ERROR_COLLECTED_AND_REMOVED_MEDICATION";
export const RESET_COLLECTED_AND_REMOVED_MEDICATION =
  "RESET_COLLECTED_AND_REMOVED_MEDICATION";

export const START_COLLECT_MARK_AS_URGENT = "START_COLLECT_MARK_AS_URGENT";
export const SUCCESS_COLLECT_MARK_AS_URGENT = "SUCCESS_COLLECT_MARK_AS_URGENT";
export const ERROR_COLLECT_MARK_AS_URGENT = "ERROR_COLLECT_MARK_AS_URGENT";

export const START_CREATE_RX = "START_CREATE_RX";
export const SUCCESS_CREATE_RX = "SUCCESS_CREATE_RX";
export const ERROR_CREATE_RX = "ERROR_CREATE_RX";

export const START_CREATE_CHASEUP = "START_CREATE_CHASEUP";
export const SUCCESS_CREATE_CHASEUP = "SUCCESS_CREATE_CHASEUP";
export const ERROR_CREATE_CHASEUP = "ERROR_CREATE_CHASEUP";

export const UPDATE_COLLECTION_DATA = "UPDATE_COLLECTION_DATA";

export const START_GET_PRINT_COLLECTION_LIST =
  "START_GET_PRINT_COLLECTION_LIST";
export const SUCCESS_GET_PRINT_COLLECTION_LIST =
  "SUCCESS_GET_PRINT_COLLECTION_LIST";
export const ERROR_GET_PRINT_COLLECTION_LIST =
  "ERROR_GET_PRINT_COLLECTION_LIST";

export const START_DRUG_NAME_UPDATE = "START_DRUG_NAME_UPDATE";
export const SUCCESS_DRUG_NAME_UPDATE = "SUCCESS_DRUG_NAME_UPDATE";
export const ERROR_DRUG_NAME_UPDATE = "ERROR_DRUG_NAME_UPDATE";

export const START_UPDATE_FIELD_COLLECTION = "START_UPDATE_FIELD_COLLECTION";
export const SUCCESS_UPDATE_FIELD_COLLECTION =
  "SUCCESS_UPDATE_FIELD_COLLECTION";
export const ERROR_UPDATE_FIELD_COLLECTION = "ERROR_UPDATE_FIELD_COLLECTION";

export const START_ARCHIVE_COLLECTION = "START_ARCHIVE_COLLECTION";
export const SUCCESS_ARCHIVE_COLLECTION = "SUCCESS_ARCHIVE_COLLECTION";
export const ERROR_ARCHIVE_COLLECTION = "ERROR_ARCHIVE_COLLECTION";

export const START_COMPLETE_COLLECTION = "START_COMPLETE_COLLECTION";
export const SUCCESS_COMPLETE_COLLECTION = "SUCCESS_COMPLETE_COLLECTION";
export const ERROR_COMPLETE_COLLECTION = "ERROR_COMPLETE_COLLECTION";
